import { useEffect, memo } from "react";
import { buildClass } from "./tag";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";

const Tooltip = dynamic(
  () => import("@mui/material").then((module) => module.Tooltip),
  {
    ssr: false,
  }
);

export const Text = memo(
  ({
    as: Component = "span",
    xs,
    className,
    width = "fit-content",
    size = "16px",
    color = "#333333",
    weight,
    top = "0px",
    fontType = "Expo_med",
    children,
    tooltip,
    ...otherProps
  }) => {
    const content = (
      <Component
        className={buildClass("relative", className)}
        style={{
          top,
          color,
          width,
          fontSize: size,
          fontWeight: weight,
          fontFamily: fontType,
          ...xs,
        }}
        {...otherProps}
      >
        {children}
      </Component>
    );

    return tooltip ? (
      <Tooltip
        title={tooltip}
        componentsProps={{
          tooltip: {
            sx: {
              bgcolor: "#000000",
              maxWidth: "200px",
            },
          },
        }}
        slotProps={{
          popper: {
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, -10],
                },
              },
            ],
          },
        }}
      >
        {content}
      </Tooltip>
    ) : (
      content
    );
  }
);

export const RedirectComponent = ({ to, setIsRedirecting }) => {
  const { push } = useRouter();
  useEffect(() => {
    push(to).then(() => {
      if (setIsRedirecting) {
        setIsRedirecting(false);
      }
    });
  }, [to, push]);

  return null;
};

export const shortText = (text, length, placeholder = "...") => {
  return text?.length > length
    ? text
        .split("")
        .slice(0, length - 1)
        .join("") + placeholder
    : text;
};

export const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

export const generateUniqueId = () =>
  `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

export const Icon = ({
  id,
  width = 24,
  height = 24,
  className,
  viewBox = "0 0 24 24",
  sx = {},
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox={viewBox}
      style={{ ...sx }}
      {...props}
    >
      <use xlinkHref={`/images/svgs/sprite.svg#${id}`} />
    </svg>
  );
};

export const capitalizeWords = (text) => {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1);
};
